import AnnouncementsService from "@/services/v3/commons/announcements.service";
import TokenService from "@/services/TokenService";
import {
    wasAnnouncementsChecked,
    markAnnouncementsChecked,
} from "@/helpers/announcements-session";

const asList = (response) => {
    const items = response && response.data && response.data.data;
    return Array.isArray(items) ? items : [];
};

/**
 * Avisos de login: lista recente (megafone/barra) + fila de pendentes
 * (modal, uma vez por sessão). Espelha o hook use-announcements do ymir.
 */
export const announcements_mixin = {
    data() {
        return {
            announcements_recent: [],
            announcements_pending: [],
            announcements_seen_ids: [],
            announcements_opened_id: null,
            announcements_drawer_open: false,
            announcements_load_id: 0,
        };
    },
    watch: {
        // Avisos só existem logado: carrega ao logar, zera ao sair.
        logged: {
            handler(is_logged) {
                if (is_logged) this.loadAnnouncements();
                else this.announcements_reset();
            },
            immediate: true,
        },
    },
    computed: {
        announcements_items() {
            return this.announcements_recent.map((item) =>
                this.announcements_seen_ids.includes(item.id)
                    ? { ...item, seen: true }
                    : item
            );
        },
        announcements_unseen_count() {
            return this.announcements_items.filter((item) => !item.seen).length;
        },
        announcements_queue_current() {
            return (
                this.announcements_pending.find(
                    (item) => !this.announcements_seen_ids.includes(item.id)
                ) || null
            );
        },
        announcements_opened() {
            if (this.announcements_opened_id === null) return null;
            const id = this.announcements_opened_id;
            return (
                this.announcements_recent.find((item) => item.id === id) ||
                this.announcements_pending.find((item) => item.id === id) ||
                null
            );
        },
        announcement_current() {
            return this.announcements_opened || this.announcements_queue_current;
        },
        announcement_queue_label() {
            const queue = this.announcements_pending;
            if (this.announcements_opened || !this.announcements_queue_current || queue.length < 2) {
                return null;
            }
            const done = queue.filter((item) =>
                this.announcements_seen_ids.includes(item.id)
            ).length;
            return `${done + 1} de ${queue.length}`;
        },
    },
    methods: {
        announcements_reset() {
            this.announcements_load_id++;
            this.announcements_recent = [];
            this.announcements_pending = [];
            this.announcements_seen_ids = [];
            this.announcements_opened_id = null;
            this.announcements_drawer_open = false;
        },

        loadAnnouncements() {
            const load_id = ++this.announcements_load_id;
            const token = new TokenService().get();
            const service = new AnnouncementsService();

            service
                .list()
                .then((response) => {
                    if (load_id === this.announcements_load_id) {
                        this.announcements_recent = asList(response);
                    }
                })
                .catch(() => {});

            if (wasAnnouncementsChecked(token)) return;

            service
                .pending()
                .then((response) => {
                    // Resposta superada (logout/troca de conta): não marca nem usa.
                    if (load_id !== this.announcements_load_id) return;
                    markAnnouncementsChecked(token);
                    this.announcements_pending = asList(response);
                })
                .catch(() => {});
        },

        openAnnouncement(id) {
            this.announcements_opened_id = id;
        },

        closeAnnouncement() {
            const current = this.announcement_current;
            if (!current) return;

            const already_seen =
                current.seen || this.announcements_seen_ids.includes(current.id);
            this.announcements_opened_id = null;
            if (already_seen) return;

            this.announcements_seen_ids = [...this.announcements_seen_ids, current.id];

            // Falha ao registrar não pode prender o usuário no aviso.
            try {
                new AnnouncementsService().seen(current.id).catch(() => {});
            } catch (e) {
                // ignorado
            }
        },
    },
};
